<template>
  <div class="logistics_wrap" >
    <van-steps direction="vertical" :active="tracesVoList.length -1" active-color="#0084FF">
      <van-step v-for="(item, index) in tracesVoList" :key="index" >
        <div class="logistics_station" >{{ item.acceptStation }}</div>
        <div class="logistics_time" >{{ item.acceptTime }}</div>
      </van-step>
    </van-steps>
    <van-empty description="暂无物流信息" v-if="tracesVoList.length <= 0" />
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import { getLogisticsInfo } from '@/api/order'
import { getLuckDrawGoodsOrderShipperInfo } from '@/api/luckdraw'
export default {
  name: 'logistics',
  data() {
    return {
      tracesVoList: []
    }
  },
  methods: {
    getLogisticsInfo() {
      const { orderId } = this.$route.params
      getLogisticsInfo({ orderId }).then(res => {
        if(res.success) {
          this.tracesVoList = res.data.tracesVoList
        }
      })
    },
    getLuckDrawGoodsOrderShipperInfo() {
      const { orderId } = this.$route.params
      getLuckDrawGoodsOrderShipperInfo({ luckDrawGoodsOrderId: orderId }).then(res => {
        if(res.success) {
          this.tracesVoList = res.data.goodsOrderShipperInfoList
        }
      })
    }
  },
  mounted() {
    const { type } = this.$route.params
    switch (type) {
      case '1':
        this.getLogisticsInfo()
        break
      case '2':
        this.getLuckDrawGoodsOrderShipperInfo()
        break
    }
  }
}
</script>
